<template>
    <div class="account-setting">
        <v-container fluid grid-list-lg>
            <v-row>
                <v-col>
                    <h2 class="primary--text">Extension chrome lọc bạn bè facebook</h2>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-text>
                            <p class="text-bold text-red">Hướng dẫn cài đặt tiện ích</p>
                            <p>
                                B1: Sử dụng Chrome phiên bản mới nhất, không được dùng CocCoc<br/>
                                B2: Tải tiện ích về và <span class="text-bold text-blue">Giải Nén</span><br/>
                                B3: Copy địa chỉ sau : <span class="text-bold text-blue">chrome://extensions/</span><br/>
                                B4: Dán lên địa chỉ web trình duyệt Chrome và truy cập<br/>
                                B5: Bật "<span class="text-bold text-blue">Chế độ dành cho nhà phát triển</span>"<br/>
                                B6: Bấm "<span class="text-bold text-blue">Tải tiện ích đã giải nén</span>"<br/>
                                B7: Chọn thư mục "<span class="text-bold text-blue">amai-filter-friends</span>" vừa giải nén ra<br/>
                            </p>
                            <p class="text-bold text-red">Chú ý:</p>
                            <p>
                                + 1 ngày Facebook chỉ cho xóa tối đa 1000 bạn bè không nên xóa hơn. <br/>
                                + Nick Facebook nên bật bảo mật 2 lớp trước khi sử dụng tiện ích <br/>
                                + Đăng kí vip trực tiếp trên extension <br/>
                                + Chúng tôi không hoàn lại gói VIP đã Thanh Toán.
                            </p>
                        </v-card-text>
                        <div class="text-center mt-2">
                            <div class="my-2">
                                <v-btn block color="primary" dark href="https://uid.bufflike.net/extensions/amai-filter-friends.zip" target="_blank">Tải xuống extension</v-btn>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>

            <!--video youtube-->
            <v-layout align-center row v-if="videoId" id="videoRef">
                <v-flex md8>
                    <div class="col-sm-12 mb-n3">
                        <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                    </div>
                    <div class="col-sm-12 mb-n3">
                        <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                        </youtube>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import {
        CONFIG_OTHER_PAGE
    } from '~/store/actions.type'
    
    export default {
        name: 'FilterFriends',
        data() {
            return {
                videoId: '',
                videoStatus: true,
            }
        },
        created () {
            this.customDataFromApi()
        },
        methods: {
            async customDataFromApi () {
                this.data = await this.$store.dispatch(CONFIG_OTHER_PAGE);
                for (let i = 0; i < this.data.length; i++) {
                    if (this.data[i].type === 'extensions_filter_friend') {
                        if (this.data[i].video) {
                            let videoId = this.youtube_parser(this.data[i].video);
                            if (videoId) {
                                this.videoId = videoId;
                            }
                        }
                    }
                }
            },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    };
</script>
<style lang="scss">
    @import "../../../scss/main";
    .my-2 {
        margin-left: 5px;
        margin-right: 5px;
    }
    .text-red {
        color: #FF8576;
    }
    .text-bold {
        font-weight: bold;
    }
    .text-blue {
        color: blue;
    }
    .extension-price {
        font-size: 1.3em;
        color: blue;
    }
</style>
